import queryString from 'query-string';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useAppDispatch } from 'app/store';
import { addAlertAction } from 'app/store/Alerts/slice';
import { fetchConnectionsEffect } from 'app/store/Profile/effects';
import { config } from 'config';
import { ConnectionStatus } from 'app/utils/utils.types';
import { getConnectionStatusMessage } from 'app/utils/utils';
import {
  connectedToSoundcloudAction,
  connectedToTuneCoreAction,
} from 'app/store/Mixpanel/slice';
import { AccountConnectionProviderId } from 'types/profile';

export const useHandleConnectionUrlPayload = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const connectionStatus = parsed?.connectionStatus as ConnectionStatus;
    const connectionName = parsed?.connectionName as string | undefined;
    const providerId = parsed?.providerId as AccountConnectionProviderId;
    const shouldRefetchConnections =
      connectionStatus === 'successful' && config.isElectronBuild && providerId;
    if (connectionStatus) {
      const message = getConnectionStatusMessage(
        connectionStatus,
        providerId,
        connectionName
      );
      if (shouldRefetchConnections) {
        dispatch(fetchConnectionsEffect({ providerId }));
      }
      if (message) {
        dispatch(
          addAlertAction({
            message,
            autoHideDuration: 4000,
          })
        );
      }

      if (connectionStatus === 'successful') {
        if (providerId === 'SoundCloud') {
          dispatch(connectedToSoundcloudAction());
        }
        if (providerId === 'TuneCore') {
          dispatch(connectedToTuneCoreAction());
        }
      }
      navigate({ search: '' }, { replace: true });
    }
  }, [dispatch, navigate, location.search]);
};
